import NamedDto from 'modules/base/dto/NamedDto';

export default class PiAfEventReaderTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.piConnection = null;
		/** @type {string} */
		this.database = null;
		/** @type {string} */
		this.templateName = null;
	}

	/**
	 * @typedef {Object} _PiAfEventReaderTableDtoProps
	 * @property {import("modules/base/dto/NamedDto").NamedDtoProps} piConnection
	 * @property {string} database
	 * @property {string} templateName
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiAfEventReaderTableDtoProps} PiAfEventReaderTableDtoProps
	 */
	/**
	 * @param {PiAfEventReaderTableDtoProps} props
	 * @returns {PiAfEventReaderTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.piConnection = props?.piConnection != null ? new NamedDto().setup(props.piConnection) : null;
		this.database = props?.database;
		this.templateName = props?.templateName;
		return this;
	}
}
